import React from 'react'
import {useIntl} from 'react-intl'
import {Button, TransparentButton} from '../../../../../_gori/partials/widgets'
import {CSSTransition} from 'react-transition-group'
import {KTSVG} from '../../../../../_gori/helpers'
import {isEmpty} from 'lodash'
import {STEPS} from '../../core/_const'

type Props = {
  setActiveStep: any
  formik: any
  setSaveAndExit: any
}

const SelectedPlan: React.FC<Props> = ({setActiveStep, formik, setSaveAndExit}) => {
  const intl = useIntl()

  const backStep = () => {
    setActiveStep(STEPS.single_step)
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-12 mx-auto mw-700px'>
                <div className='card bg-white'>
                  <div className='card-header bg-white border-bottom'>
                    <h4 className='card-title text-start fw-bolder fs-1 lh-base text-capitalize mb-0 py-5'>
                      {intl.formatMessage({id: 'SELECT_PLAN'})}
                    </h4>
                  </div>
                  <div className='card-body'>
                    <div className='mb-4 px-5'>
                      <div className='d-flex justify-content-center align-items-center mt-10 mb-15'>
                        <KTSVG
                          path='/media/gori/onboard/welcome/completed-check.svg'
                          svgClassName='w-120px h-120px'
                          small={false}
                        />
                      </div>
                      <p className='mb-3 roboto fw-boldest text-center fs-3 lh-lg'>
                        {intl.formatMessage({id: 'ENTERPRISE_REQUEST_SUBMITTED'})}
                      </p>
                      <p className='mb-0 roboto fw-bold text-center fs-3 lh-lg'>
                        {intl.formatMessage({id: 'ENTERPRISE_SALES_REP_NOTICE'})}
                      </p>
                    </div>
                  </div>
                  <div className='card-footer bg-white border-top'>
                    <div className='d-flex justify-content-end'>
                      <Button
                        className='btn btn-advanced-primary'
                        label={intl.formatMessage({id: 'NEXT'})}
                        loadingText={intl.formatMessage({id: 'NEXT'})}
                        loading={formik.isSubmitting}
                        event={() => {
                          formik.submitForm()
                        }}
                        disabled={formik.isSubmitting || !isEmpty(formik.errors)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-block'>
            <div className='save-and-exit d-flex justify-content-end'>
              <TransparentButton
                className='btn onboard-form'
                label={intl.formatMessage({id: 'BACK'})}
                loadingText={intl.formatMessage({id: 'BACK'})}
                loading={formik.isSubmitting}
                event={() => backStep()}
                disabled={!isEmpty(formik.errors) || formik.isSubmitting}
                icon={<KTSVG path='/media/gori/arrows/arrow_left.svg' />}
              ></TransparentButton>
              <TransparentButton
                className='btn me-20'
                label={intl.formatMessage({id: 'SAVE_AND_EXIT'})}
                loadingText={intl.formatMessage({id: 'SAVE_AND_EXIT'})}
                loading={formik.isSubmitting}
                event={async () => {
                  await setSaveAndExit(true)
                  formik.handleSubmit()
                }}
                disabled={!isEmpty(formik.errors) || formik.isSubmitting}
              >
                <KTSVG
                  path='/media/gori/orders/delete.svg'
                  className='m-0'
                  svgClassName='mh-10px'
                />
              </TransparentButton>
            </div>
          </div>
        </>
      </CSSTransition>
    </>
  )
}

export {SelectedPlan}
